import axios from "axios";
import { clearAuthToken, getAuthToken } from "./utils/authToken";

const rawApiUrl = String(
  process.env.REACT_APP_API_URL || "http://localhost:8080/api/v1",
).trim();
export const apiBaseOrigin = rawApiUrl.replace(/\/+$/, "");

console.log({ apiBaseOrigin });
export const api = axios.create({
  baseURL: apiBaseOrigin,
  
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestUrl = String(err?.config?.url || "");
    const isLoginRequest =
      requestUrl.includes("/auth/login") ||
      requestUrl.endsWith("/login");

    if (err?.response?.status === 401 && !isLoginRequest) {
      clearAuthToken();
      localStorage.clear();
      window.location.href = "/";
    }

    if (err?.response?.status === 404 && err?.response?.data?.message) {
      const msg = String(err.response.data.message).toLowerCase();
      if (
        msg.includes("membro da família não encontrado") ||
        msg.includes("persona não encontrada")
      ) {
        clearAuthToken();
        localStorage.clear();
        window.location.href = "/";
      }
    }

    return Promise.reject(err);
  },
);
